import { escapeRegExp } from 'lodash';

/* Cal.com has no concept of a "walkthrough" or "key pickup" event type — every event type is just
 * a link, so the backend can't enforce that a booking link points at the right kind. legacy/workaround:
 * the closest signal we have is the human-given event type name, so we soft-match on that and let the
 * user confirm rather than blocking them. */
export const buildKindNamePattern = (kindLabel: string): RegExp => {
  const tokens: string[] = kindLabel
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((token: string) => escapeRegExp(token));

  return new RegExp(tokens.join('[\\s-]*'), 'i');
};

export interface KindNameMatch {
  before: string;
  match: string;
  after: string;
}

export const findKindNameMatch = (
  eventTypeTitle: string,
  kindLabel: string
): KindNameMatch | null => {
  const result: RegExpExecArray | null =
    buildKindNamePattern(kindLabel).exec(eventTypeTitle);

  if (!result) {
    return null;
  }

  const start: number = result.index;
  const end: number = start + result[0].length;

  return {
    before: eventTypeTitle.slice(0, start),
    match: eventTypeTitle.slice(start, end),
    after: eventTypeTitle.slice(end),
  };
};